(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chakra-explorer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ezcReady) return;
      root.dataset.ezcReady = '1';
      var triggers = root.querySelectorAll('[data-ezc-select]');
      var panels = root.querySelectorAll('[data-ezc-panel]');
      if (!panels.length) return;
      var mq = window.matchMedia('(max-width: 989px)');

      function select(i, scroll) {
        panels.forEach(function (p) { p.hidden = p.dataset.ezcPanel !== String(i); });
        triggers.forEach(function (t) {
          var on = t.dataset.ezcSelect === String(i);
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on && mq.matches) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        var active = root.querySelector('[data-ezc-panel="' + i + '"]');
        if (active && scroll) {
          var top = active.getBoundingClientRect().top;
          if (top < 0 || top > window.innerHeight * .6) active.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      triggers.forEach(function (t) {
        t.addEventListener('click', function () { select(t.dataset.ezcSelect, true); });
      });

      root.addEventListener('keydown', function (e) {
        if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) === -1) return;
        if (!e.target.matches('[data-ezc-select]')) return;
        e.preventDefault();
        var cur = parseInt(e.target.dataset.ezcSelect, 10);
        var up = mq.matches ? (e.key === 'ArrowRight' || e.key === 'ArrowDown') : (e.key === 'ArrowUp' || e.key === 'ArrowRight');
        var next = (cur + (up ? 1 : -1) + panels.length) % panels.length;
        select(next, false);
        var btn = root.querySelector('[data-ezc-select="' + next + '"]');
        if (btn) btn.focus();
      });

      var m = location.hash.match(/csakra-(\d+)/);
      if (m) select(parseInt(m[1], 10) - 1, false);
    }

    document.querySelectorAll('[data-ezc]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-ezc]');
      if (r) init(r);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target.closest && e.target.closest('[data-ezc-panel]');
      var r = panel && panel.closest('[data-ezc]');
      if (r) {
        var btn = r.querySelector('[data-ezc-select="' + panel.dataset.ezcPanel + '"]');
        if (btn) btn.click();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ez-crystal-world"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var C = {
      rose: ['Rózsakvarc', 'Rose Quartz', '#f7dfe6', '#d79aab'],
      ame: ['Ametiszt', 'Amethyst', '#e2d2f0', '#8e63b8'],
      tiger: ['Tigrisszem', 'Tiger Eye', '#efcf8f', '#8a5a1c'],
      carn: ['Karneol', 'Carnelian', '#f6c19c', '#c0562a'],
      tour: ['Fekete turmalin', 'Black Tourmaline', '#77727c', '#1d1a21'],
      fluo: ['Fluorit', 'Fluorite', '#d3ece4', '#7d6bb5'],
      lab: ['Labradorit', 'Labradorite', '#c3d0dc', '#3f5a70'],
      sun: ['Napkő', 'Sunstone', '#f8d7a8', '#d9793a'],
      smoky: ['Füstkvarc', 'Smoky Quartz', '#d6c7b8', '#5e4b3f'],
      aqua: ['Akvamarin', 'Aquamarine', '#e0f2f5', '#7fb8c8'],
      cit: ['Citrin', 'Citrine', '#fae8a6', '#d6a02a'],
      moon: ['Holdkő', 'Moonstone', '#ffffff', '#c9c6d2'],
      amaz: ['Amazonit', 'Amazonite', '#d6efe8', '#5fae9d'],
      opal: ['Opál', 'Opal', '#f6f1f8', '#b9d2e6'],
      obs: ['Obszidián', 'Obsidian', '#66606c', '#121014'],
      turq: ['Türkiz', 'Turquoise', '#c5ece7', '#3fa39a'],
      jasper: ['Vörös jáspis', 'Red Jasper', '#e3a08c', '#8e3222'],
      hem: ['Hematit', 'Hematite', '#a6a3a8', '#3a383d'],
      aven: ['Zöld aventurin', 'Green Aventurine', '#cfe8c9', '#4f8f4a'],
      mala: ['Malachit', 'Malachite', '#9ed3b3', '#1f6b45'],
      emer: ['Smaragd', 'Emerald', '#b8e6c8', '#1d8a56'],
      agate: ['Achát', 'Agate', '#e8ddd3', '#8c7461'],
      apat: ['Apatit', 'Apatite', '#bfe6f0', '#1c8fb0'],
      sele: ['Szelenit', 'Selenite', '#ffffff', '#dcd9e0'],
      moss: ['Mohaachát', 'Moss Agate', '#e2eadb', '#5f7f4e'],
      clear: ['Hegyikristály', 'Clear Quartz', '#ffffff', '#d7dde4'],
      lapis: ['Lápisz lazuli', 'Lapis Lazuli', '#8fa6dc', '#1f3a8a'],
      garnet: ['Gránát', 'Garnet', '#d98c95', '#6e1523'],
      soda: ['Szodalit', 'Sodalite', '#a7b6e0', '#27377a'],
      onyx: ['Ónix', 'Onyx', '#5b5761', '#141216']
    };

    var T = {
      hu: {
        back: 'Vissza a választáshoz', see: 'Megnézem a köveket', again: 'Újrakezdem', step: 'kérdés',
        finder: { k: 'Kristálykereső', h: 'Mire van most a legnagyobb szükséged?', p: 'Ne gondolkodj túl sokat. Válaszd mindig azt, ami elsőre a legjobban megszólít.',
          qs: [
            ['Mit szeretnél most erősíteni?', [['love', 'Szeretet'], ['calm', 'Nyugalom'], ['power', 'Önbizalom'], ['creative', 'Kreativitás'], ['protect', 'Védelem'], ['focus', 'Fókusz']]],
            ['Milyen energiához vonzódsz?', [['calm', 'Lágy'], ['power', 'Erőteljes'], ['protect', 'Földelő'], ['creative', 'Ragyogó'], ['focus', 'Tiszta'], ['love', 'Meleg']]],
            ['Válassz ösztönösen egy színt.', [['love', 'Rózsaszín', '#f3c9d4', '#d796a8'], ['calm', 'Lila', '#d8c6e6', '#9a79ab'], ['focus', 'Kék', '#cfe5ef', '#76acc5'], ['protect', 'Fekete', '#6d686f', '#2b272c'], ['creative', 'Narancs', '#f6caa9', '#e09b67'], ['power', 'Arany', '#f1dc9e', '#d4ad51']]]
          ],
          rh: 'A te kristálytriód', main: 'Fő találat', sup: 'Támogató kristály',
          res: { love: ['rose', 'A szeretethez, gyengédséghez és harmonikus kapcsolódáshoz társított klasszikus kristály.'], calm: ['ame', 'Hagyományosan a belső nyugalomhoz, intuícióhoz és elmélyüléshez kapcsolják.'], power: ['tiger', 'Az önbizalomhoz, bátorsághoz és határozottsághoz társított ásvány.'], creative: ['carn', 'A motiváció, kreativitás és lendület egyik legismertebb szimbolikus köve.'], protect: ['tour', 'Hagyományosan a védelemhez, stabilitáshoz és földeléshez kapcsolják.'], focus: ['fluo', 'A fókuszhoz, tiszta gondolkodáshoz és rendszerezéshez társított ásvány.'] } },
        daily: { k: 'A nap kristálya', h: 'Melyik kristály talál meg ma?', p: 'Egy pillanatra engedd el a gondolkodást. Amikor készen állsz, fedd fel a mai kristályodat.', btn: 'Felfedem a mai kristályomat', lab: 'A mai kristályod', theme: 'Mai témád: ',
          list: [
            ['lab', 'Új perspektíva', 'Ma érdemes lehet más szemszögből ránézned valamire. A Labradoritot hagyományosan az intuícióval, változással és új lehetőségek felismerésével társítják.', 'Intuíció, Változás, Felfedezés'],
            ['ame', 'Csend', 'A mai nap üzenete a lassítás. Az Ametisztet a belső nyugalomhoz, intuícióhoz és elmélyüléshez kapcsolják.', 'Nyugalom, Intuíció, Belső béke'],
            ['carn', 'Mozdulj', 'Valami talán már régóta vár arra, hogy elkezdd. A Karneol a motivációval, kreativitással és tetterővel kapcsolódik össze.', 'Motiváció, Kreativitás, Lendület'],
            ['rose', 'Gyengédség', 'Ma figyelj arra, hogyan beszélsz önmagaddal és másokkal. A Rózsakvarcot a szeretettel és harmonikus kapcsolódással társítják.', 'Szeretet, Kapcsolódás, Gyengédség'],
            ['fluo', 'Tisztázás', 'Ha túl sok minden kavarog körülötted, válassz ki egyetlen dolgot. A Fluorit a fókuszhoz és rendezett gondolkodáshoz kapcsolódik.', 'Fókusz, Rendszer, Tisztaság'],
            ['sun', 'Ragyogás', 'Ma adj egy kicsit több teret annak, ami örömet okoz. A Napkövet az önbizalommal, optimizmussal és örömmel társítják.', 'Öröm, Önbizalom, Ragyogás'],
            ['smoky', 'Földelés', 'Nem kell mindent egyszerre megoldani. A Füstkvarcot a stabilitással, jelenléttel és földelő energiával kapcsolják össze.', 'Stabilitás, Jelenlét, Földelés'],
            ['aqua', 'Tiszta szó', 'Ma mondd ki egyszerűen azt, amit valóban gondolsz. Az Akvamarint a nyugalomhoz és tiszta kommunikációhoz társítják.', 'Kommunikáció, Nyugalom, Őszinteség'],
            ['cit', 'Lehetőség', 'Figyeld meg, hol van ma egy apró lehetőség, amit könnyű lenne észre sem venni. A Citrint optimizmussal és kreatív energiával társítják.', 'Lehetőség, Derű, Kreativitás'],
            ['moon', 'Intuíció', 'Nem minden döntéshez kell hosszú magyarázat. A Holdkövet az intuícióhoz és belső ciklusokhoz kapcsolják.', 'Intuíció, Érzékenység, Belső iránytű']
          ] },
        cards: { k: '3 kristálykártya', h: 'Válassz három kártyát', p: 'Ne próbáld kitalálni, mi van mögöttük. Válaszd ki egymás után azt a három kártyát, amelyik a legjobban vonz.', cue: ['Válaszd ki az első kártyádat', 'Most válaszd ki a másodikat', 'És végül a harmadikat', 'Ez a három kristály választott ma téged'], labels: ['Amit magaddal hozol', 'Ami most körülvesz', 'Ami felé érdemes figyelned'], card: 'Kártya', again: 'Új kártyák',
          list: [['ame', 'Csend', 'Nem minden válasz érkezik zajosan.'], ['carn', 'Mozgás', 'A következő lépés fontosabb lehet, mint a tökéletes terv.'], ['lab', 'Változás', 'Nézd meg ugyanazt a helyzetet egy másik nézőpontból.'], ['rose', 'Szeretet', 'Adj abból a gyengédségből önmagadnak is, amit másoknak adsz.'], ['fluo', 'Fókusz', 'Válassz ki egy dolgot, és adj neki teljes figyelmet.'], ['tiger', 'Bátorság', 'Bízz jobban abban, amit már most is tudsz.'], ['moon', 'Intuíció', 'Az első megérzésed talán fontosabb, mint gondolnád.'], ['smoky', 'Stabilitás', 'Térj vissza ahhoz, ami valóban a te kezedben van.'], ['cit', 'Öröm', 'Figyeld meg azt is, ami már most jól működik.'], ['tour', 'Határok', 'Nem kell minden energiát magaddal vinned.'], ['aqua', 'Kommunikáció', 'Mondd ki egyszerűen azt, amit valóban szeretnél.'], ['sun', 'Ragyogás', 'Engedd meg magadnak, hogy látható legyél.']] },
        zodiac: { k: 'Csillagjegy és kristály', h: 'Válaszd ki a csillagjegyed', p: 'Fedezd fel a jegyedhez hagyományosan kapcsolódó fő kristályt és három további ásványt.', lab: 'A jegyed kristálya', also: 'További kristályok: ',
          list: [
            ['♈', 'Kos', 'carn', 'A Karneolt a motivációval, bátorsággal és lendülettel társítják, így jól rezonálhat a Kos kezdeményező energiájával.', 'jasper,tiger,hem'],
            ['♉', 'Bika', 'rose', 'A Vénusz által uralt Bikához szépen kapcsolódik a szeretet, harmónia és gyengédség szimbolikáját hordozó Rózsakvarc.', 'aven,mala,emer'],
            ['♊', 'Ikrek', 'fluo', 'A Fluoritot tiszta gondolkodással és fókuszálással társítják, ezért érdekes kísérője lehet az állandóan kíváncsi Ikreknek.', 'agate,cit,apat'],
            ['♋', 'Rák', 'moon', 'A Holdkő intuícióhoz és érzelmi ciklusokhoz kapcsolódó szimbolikája természetesen illik a Hold által uralt Rákhoz.', 'rose,aqua,sele'],
            ['♌', 'Oroszlán', 'sun', 'A Napkövet az öröm, önbizalom és ragyogó személyes energia kristályaként tartják számon.', 'cit,carn,tiger'],
            ['♍', 'Szűz', 'amaz', 'Az Amazonit egyensúlyhoz és nyugodt önkifejezéshez kapcsolódó szimbolikája jól kiegészítheti a Szűz precíz természetét.', 'fluo,moss,clear'],
            ['♎', 'Mérleg', 'opal', 'Az Opált a szépséggel, kreatív önkifejezéssel és érzelmekkel kapcsolják össze, így jól illeszkedik a Vénusz által uralt Mérleghez.', 'rose,lapis,aven'],
            ['♏', 'Skorpió', 'obs', 'Az Obszidiánt átalakulással, önismerettel és védelemmel társítják, ezek erős témák a Skorpió számára.', 'garnet,mala,tour'],
            ['♐', 'Nyilas', 'turq', 'A Türkiz hosszú hagyományokban az utazáshoz, kommunikációhoz és védelemhez kapcsolódik.', 'ame,lapis,soda'],
            ['♑', 'Bak', 'smoky', 'A Füstkvarc földelő és stabilizáló szimbolikája jól kapcsolódik a Bak kitartó és céltudatos természetéhez.', 'onyx,garnet,hem'],
            ['♒', 'Vízöntő', 'lab', 'A Labradoritot új perspektívákkal, intuícióval és változással kapcsolják össze, így jól illik a Vízöntő eredeti gondolkodásához.', 'ame,fluo,aqua'],
            ['♓', 'Halak', 'ame', 'Az Ametiszt intuícióhoz és belső elmélyüléshez kapcsolódó szimbolikája szépen rezonálhat az érzékeny Halakkal.', 'aqua,moon,lab']
          ] },
        mood: { k: 'Kristály hangulat alapján', h: 'Hogy érzed magad most?', p: 'Néha érdemes abból kiindulni, ahol éppen vagy.', lab: 'Próbáld ki ezt a kristályt',
          list: [
            ['Stresszes vagyok', 'Túl sok minden történik.', 'ame', 'Ha sok minden kavarog körülötted, az Ametiszt szimbolikája emlékeztethet arra, hogy teremts egy kis csendet és teret magad körül.', 'Nyugalom, Lassítás, Belső tér'],
            ['Fáradt vagyok', 'Jól jönne egy kis lendület.', 'carn', 'A Karneolt hagyományosan a motivációhoz, kreativitáshoz és aktív energiához kapcsolják.', 'Energia, Motiváció, Lendület'],
            ['Inspirációt keresek', 'Valami újat szeretnék.', 'lab', 'A Labradoritot kreativitással, új nézőpontokkal és intuícióval társítják.', 'Ötlet, Intuíció, Felfedezés'],
            ['Szeretetre vágyom', 'Több gyengédség kellene.', 'rose', 'A Rózsakvarc a szeretet, kapcsolódás és gyengédség egyik legismertebb szimbolikus ásványa.', 'Szeretet, Kapcsolódás, Gyengédség'],
            ['Nem tudok fókuszálni', 'Szétszórtnak érzem magam.', 'fluo', 'A Fluoritot a fókuszhoz, tiszta gondolkodáshoz és rendszerezéshez kapcsolják.', 'Fókusz, Rendszer, Tisztaság'],
            ['Bizonytalan vagyok', 'Több önbizalmat szeretnék.', 'tiger', 'A Tigrisszemet hagyományosan bátorsággal, önbizalommal és határozottsággal társítják.', 'Önbizalom, Bátorság, Határozottság'],
            ['Túl sok energiát veszek át', 'Szükségem van határokra.', 'tour', 'A Fekete turmalint védelemmel, stabilitással és földeléssel kapcsolják össze.', 'Védelem, Határok, Földelés'],
            ['Jól vagyok', 'Ezt az energiát szeretném megtartani.', 'sun', 'A Napkő az örömhöz, optimizmushoz és önbizalomhoz kapcsolódó kristály.', 'Öröm, Ragyogás, Pozitivitás']
          ] }
      },
      en: {
        back: 'Back to the games', see: 'See the stones', again: 'Start again', step: 'question',
        finder: { k: 'Crystal finder', h: 'What do you need most right now?', p: 'Don’t overthink it. Always pick the one that speaks to you first.',
          qs: [
            ['What would you like to strengthen?', [['love', 'Love'], ['calm', 'Calm'], ['power', 'Confidence'], ['creative', 'Creativity'], ['protect', 'Protection'], ['focus', 'Focus']]],
            ['Which energy draws you in?', [['calm', 'Soft'], ['power', 'Strong'], ['protect', 'Grounding'], ['creative', 'Radiant'], ['focus', 'Clear'], ['love', 'Warm']]],
            ['Pick a colour by instinct.', [['love', 'Pink', '#f3c9d4', '#d796a8'], ['calm', 'Purple', '#d8c6e6', '#9a79ab'], ['focus', 'Blue', '#cfe5ef', '#76acc5'], ['protect', 'Black', '#6d686f', '#2b272c'], ['creative', 'Orange', '#f6caa9', '#e09b67'], ['power', 'Gold', '#f1dc9e', '#d4ad51']]]
          ],
          rh: 'Your crystal trio', main: 'Best match', sup: 'Supporting crystal',
          res: { love: ['rose', 'The classic crystal of love, tenderness and harmonious connection.'], calm: ['ame', 'Traditionally linked to inner calm, intuition and reflection.'], power: ['tiger', 'A stone associated with confidence, courage and decisiveness.'], creative: ['carn', 'One of the best-known symbolic stones of motivation, creativity and drive.'], protect: ['tour', 'Traditionally linked to protection, stability and grounding.'], focus: ['fluo', 'A mineral associated with focus, clear thinking and order.'] } },
        daily: { k: 'Crystal of the day', h: 'Which crystal finds you today?', p: 'Let go of thinking for a moment. When you’re ready, reveal today’s crystal.', btn: 'Reveal my crystal for today', lab: 'Your crystal today', theme: 'Today’s theme: ',
          list: [
            ['lab', 'A new perspective', 'Today it may help to look at something from another angle. Labradorite is traditionally linked to intuition, change and spotting new possibilities.', 'Intuition, Change, Discovery'],
            ['ame', 'Stillness', 'Today’s message is to slow down. Amethyst is linked to inner calm, intuition and reflection.', 'Calm, Intuition, Inner peace'],
            ['carn', 'Move', 'Something may have been waiting a long time for you to start it. Carnelian is connected with motivation, creativity and drive.', 'Motivation, Creativity, Drive'],
            ['rose', 'Tenderness', 'Notice how you speak to yourself and to others today. Rose Quartz is associated with love and harmonious connection.', 'Love, Connection, Tenderness'],
            ['fluo', 'Clarity', 'If too much is swirling around you, choose just one thing. Fluorite is linked to focus and orderly thinking.', 'Focus, Order, Clarity'],
            ['sun', 'Shine', 'Give a little more room today to what brings you joy. Sunstone is associated with confidence, optimism and joy.', 'Joy, Confidence, Radiance'],
            ['smoky', 'Grounding', 'You don’t have to solve everything at once. Smoky Quartz is linked to stability, presence and grounding energy.', 'Stability, Presence, Grounding'],
            ['aqua', 'Clear words', 'Today, simply say what you really think. Aquamarine is associated with calm and clear communication.', 'Communication, Calm, Honesty'],
            ['cit', 'Opportunity', 'Notice the small opportunity today that would be easy to miss. Citrine is associated with optimism and creative energy.', 'Opportunity, Cheer, Creativity'],
            ['moon', 'Intuition', 'Not every decision needs a long explanation. Moonstone is linked to intuition and inner cycles.', 'Intuition, Sensitivity, Inner compass']
          ] },
        cards: { k: '3 crystal cards', h: 'Pick three cards', p: 'Don’t try to guess what’s behind them. Pick, one after another, the three cards that draw you most.', cue: ['Pick your first card', 'Now pick the second', 'And finally the third', 'These three crystals chose you today'], labels: ['What you bring with you', 'What surrounds you now', 'What to turn towards'], card: 'Card', again: 'New cards',
          list: [['ame', 'Stillness', 'Not every answer arrives loudly.'], ['carn', 'Movement', 'The next step may matter more than the perfect plan.'], ['lab', 'Change', 'Look at the same situation from another point of view.'], ['rose', 'Love', 'Give yourself some of the tenderness you give others.'], ['fluo', 'Focus', 'Choose one thing and give it your full attention.'], ['tiger', 'Courage', 'Trust more in what you already know.'], ['moon', 'Intuition', 'Your first feeling may matter more than you think.'], ['smoky', 'Stability', 'Come back to what is truly in your hands.'], ['cit', 'Joy', 'Notice what is already working well.'], ['tour', 'Boundaries', 'You don’t have to carry every energy with you.'], ['aqua', 'Communication', 'Simply say what you really want.'], ['sun', 'Radiance', 'Allow yourself to be seen.']] },
        zodiac: { k: 'Zodiac and crystals', h: 'Choose your zodiac sign', p: 'Discover the main crystal traditionally linked to your sign, plus three more.', lab: 'Your sign’s crystal', also: 'Also for you: ',
          list: [
            ['♈', 'Aries', 'carn', 'Carnelian is associated with motivation, courage and drive, so it can resonate well with Aries’ pioneering energy.', 'jasper,tiger,hem'],
            ['♉', 'Taurus', 'rose', 'Venus-ruled Taurus pairs beautifully with Rose Quartz and its symbolism of love, harmony and tenderness.', 'aven,mala,emer'],
            ['♊', 'Gemini', 'fluo', 'Fluorite is linked to clear thinking and focus, making it an interesting companion for ever-curious Gemini.', 'agate,cit,apat'],
            ['♋', 'Cancer', 'moon', 'Moonstone’s link to intuition and emotional cycles naturally suits Moon-ruled Cancer.', 'rose,aqua,sele'],
            ['♌', 'Leo', 'sun', 'Sunstone is known as the crystal of joy, confidence and radiant personal energy.', 'cit,carn,tiger'],
            ['♍', 'Virgo', 'amaz', 'Amazonite’s symbolism of balance and calm self-expression can complement Virgo’s precise nature.', 'fluo,moss,clear'],
            ['♎', 'Libra', 'opal', 'Opal is connected with beauty, creative expression and emotion, a good fit for Venus-ruled Libra.', 'rose,lapis,aven'],
            ['♏', 'Scorpio', 'obs', 'Obsidian is associated with transformation, self-knowledge and protection, all strong themes for Scorpio.', 'garnet,mala,tour'],
            ['♐', 'Sagittarius', 'turq', 'In long traditions, Turquoise is linked to travel, communication and protection.', 'ame,lapis,soda'],
            ['♑', 'Capricorn', 'smoky', 'Smoky Quartz’s grounding, stabilising symbolism suits Capricorn’s steady, goal-driven nature.', 'onyx,garnet,hem'],
            ['♒', 'Aquarius', 'lab', 'Labradorite is linked to new perspectives, intuition and change, a good match for Aquarius’ original thinking.', 'ame,fluo,aqua'],
            ['♓', 'Pisces', 'ame', 'Amethyst’s symbolism of intuition and inner depth can resonate beautifully with sensitive Pisces.', 'aqua,moon,lab']
          ] },
        mood: { k: 'Crystal by mood', h: 'How do you feel right now?', p: 'Sometimes it’s worth starting from where you are.', lab: 'Try this crystal',
          list: [
            ['I’m stressed', 'Too much is going on.', 'ame', 'When a lot is swirling around you, Amethyst’s symbolism can remind you to create some quiet and space around yourself.', 'Calm, Slowing down, Inner space'],
            ['I’m tired', 'I could use some energy.', 'carn', 'Carnelian is traditionally linked to motivation, creativity and active energy.', 'Energy, Motivation, Drive'],
            ['I need inspiration', 'I want something new.', 'lab', 'Labradorite is associated with creativity, new perspectives and intuition.', 'Ideas, Intuition, Discovery'],
            ['I long for love', 'I need more tenderness.', 'rose', 'Rose Quartz is one of the best-known symbolic stones of love, connection and tenderness.', 'Love, Connection, Tenderness'],
            ['I can’t focus', 'I feel scattered.', 'fluo', 'Fluorite is linked to focus, clear thinking and order.', 'Focus, Order, Clarity'],
            ['I feel unsure', 'I want more confidence.', 'tiger', 'Tiger Eye is traditionally associated with courage, confidence and decisiveness.', 'Confidence, Courage, Decisiveness'],
            ['I absorb too much energy', 'I need boundaries.', 'tour', 'Black Tourmaline is connected with protection, stability and grounding.', 'Protection, Boundaries, Grounding'],
            ['I feel good', 'I want to keep this energy.', 'sun', 'Sunstone is the crystal of joy, optimism and confidence.', 'Joy, Radiance, Positivity']
          ] }
      }
    };

    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    document.querySelectorAll('[data-ezw]').forEach(function (root) {
      if (root.dataset.ezwReady) return;
      root.dataset.ezwReady = '1';
      var L = root.dataset.lang === 'en' ? 'en' : 'hu';
      var li = L === 'en' ? 1 : 0;
      var t = T[L];
      var search = root.dataset.search || '/search';
      var panel = root.querySelector('[data-ezw-panel]');
      var items = root.querySelectorAll('[data-ezw-open]');
      var current = '';
      var ST = {};
      try { ST = JSON.parse(root.querySelector('[data-ezw-stones]').textContent) || {}; } catch (e) { ST = {}; }
      function img(id) { return ST[id] && ST[id].i ? ST[id].i : ''; }

      function nm(id) { return C[id] ? C[id][li] : id; }
      function dot(id, lg) {
        var p = img(id);
        if (p) return '<span class="ezw__pic' + (lg ? '' : ' ezw__pic--sm') + '" aria-hidden="true"><img src="' + p + '" alt="" loading="lazy"></span>';
        var c = C[id] || ['', '', '#fff', '#999']; return '<span class="ezw__dot' + (lg ? ' ezw__dot--lg' : '') + '" style="--c1:' + c[2] + ';--c2:' + c[3] + '" aria-hidden="true"></span>'; }
      function more(id) { var u = ST[id] && ST[id].u ? ST[id].u : search + '?q=' + encodeURIComponent(nm(id)) + '&type=product'; return '<a class="ezw__more" href="' + u + '"><span>' + esc(t.see) + '</span></a>'; }
      function front(id) { var p = img(id); return p ? '<span class="ezw__face ezw__face--front ezw__face--photo"><span class="ezw__cimg"><img src="' + p + '" alt="" loading="lazy"></span><span>' + esc(nm(id)) + '</span></span>' : '<span class="ezw__face ezw__face--front">' + dot(id) + '<span>' + esc(nm(id)) + '</span></span>'; }
      function kw(s) { return s.split(/\s*,\s*/).join(' · '); }
      function shell(g, inner) {
        return '<div class="ezw__pin"><p class="ezw__kicker">' + esc(g.k) + '</p><h2 class="ezw__ph">' + esc(g.h) + '</h2><p class="ezw__pt">' + esc(g.p) + '</p><div class="ezw__body" data-body>' + inner + '</div><button type="button" class="ezw__back" data-back>' + esc(t.back) + '</button></div>';
      }
      function single(id, lab, theme, text, keys) {
        return '<div class="ezw__res ezw__single">' + dot(id, true) + '<p class="ezw__lab">' + esc(lab) + '</p><h3 class="ezw__rn ezw__big">' + esc(nm(id)) + '</h3>' + (theme ? '<p class="ezw__theme">' + esc(theme) + '</p>' : '') + '<p class="ezw__rt">' + esc(text) + '</p>' + (keys ? '<p class="ezw__also">' + esc(kw(keys)) + '</p>' : '') + more(id) + '</div>';
      }

      var R = {
        finder: function (body) {
          var step = 0, score = {};
          function q() {
            var d = t.finder.qs[step];
            var h = '<p class="ezw__step">' + (step + 1) + ' / 3</p><div class="ezw__bar"><span style="transform:scaleX(' + ((step + 1) / 3) + ')"></span></div><h3 class="ezw__q">' + esc(d[0]) + '</h3><div class="ezw__opts">';
            d[1].forEach(function (o) { h += '<button type="button" class="ezw__opt" data-v="' + o[0] + '">' + (o[2] ? '<span class="ezw__dot" style="--c1:' + o[2] + ';--c2:' + o[3] + '" aria-hidden="true"></span>' : '') + esc(o[1]) + '</button>'; });
            body.innerHTML = h + '</div>';
            body.querySelectorAll('[data-v]').forEach(function (b) {
              b.addEventListener('click', function () {
                score[b.dataset.v] = (score[b.dataset.v] || 0) + 1;
                step++;
                if (step < 3) { q(); body.querySelector('.ezw__opt').focus({ preventScroll: true }); } else res();
              });
            });
          }
          function res() {
            var keys = Object.keys(t.finder.res).map(function (k) { return [k, (score[k] || 0) + Math.random() * .5]; }).sort(function (a, b) { return b[1] - a[1]; }).slice(0, 3);
            var h = '<div class="ezw__res"><h3 class="ezw__q">' + esc(t.finder.rh) + '</h3><div class="ezw__grid3">';
            keys.forEach(function (k, i) { var r = t.finder.res[k[0]]; h += '<div class="ezw__rc">' + dot(r[0], true) + '<p class="ezw__lab">' + esc(i ? t.finder.sup : t.finder.main) + '</p><h4 class="ezw__rn">' + esc(nm(r[0])) + '</h4><p class="ezw__rt">' + esc(r[1]) + '</p>' + more(r[0]) + '</div>'; });
            body.innerHTML = h + '</div><button type="button" class="ezw__link" data-re>' + esc(t.again) + '</button></div>';
            body.querySelector('[data-re]').addEventListener('click', function () { step = 0; score = {}; q(); });
          }
          q();
        },
        daily: function (body) {
          body.innerHTML = '<button type="button" class="ezw__btn" data-go>' + esc(t.daily.btn) + '</button>';
          body.querySelector('[data-go]').addEventListener('click', function () {
            var n = new Date();
            var d = t.daily.list[(n.getFullYear() * 1000 + (n.getMonth() + 1) * 31 + n.getDate()) % t.daily.list.length];
            body.innerHTML = single(d[0], t.daily.lab, t.daily.theme + d[1], d[2], d[3]);
          });
        },
        cards: function (body) {
          function build() {
            var deck = t.cards.list.slice();
            for (var i = deck.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var x = deck[i]; deck[i] = deck[j]; deck[j] = x; }
            var picked = [];
            var h = '<p class="ezw__cue" aria-live="polite" data-cue>' + esc(t.cards.cue[0]) + '</p><div class="ezw__cards">';
            deck.forEach(function (c, i) { h += '<button type="button" class="ezw__card" data-i="' + i + '" aria-label="' + esc(t.cards.card) + ' ' + (i + 1) + '"><span class="ezw__card-in"><span class="ezw__face ezw__face--back"></span>' + front(c[0]) + '</span></button>'; });
            body.innerHTML = h + '</div><div data-out></div>';
            var cue = body.querySelector('[data-cue]');
            body.querySelectorAll('.ezw__card').forEach(function (b) {
              b.addEventListener('click', function () {
                if (b.classList.contains('is-on') || picked.length >= 3) return;
                b.classList.add('is-on');
                picked.push(deck[+b.dataset.i]);
                cue.textContent = t.cards.cue[picked.length];
                if (picked.length === 3) {
                  body.querySelectorAll('.ezw__card:not(.is-on)').forEach(function (o) { o.classList.add('is-muted'); o.setAttribute('aria-disabled', 'true'); });
                  setTimeout(function () {
                    var o = '<div class="ezw__res" style="margin-top:32px"><div class="ezw__grid3">';
                    picked.forEach(function (c, i) { o += '<div class="ezw__rc">' + dot(c[0], true) + '<p class="ezw__lab">' + esc(t.cards.labels[i]) + '</p><h4 class="ezw__rn">' + esc(nm(c[0])) + '</h4><p class="ezw__theme">' + esc(c[1]) + '</p><p class="ezw__rt">' + esc(c[2]) + '</p>' + more(c[0]) + '</div>'; });
                    body.querySelector('[data-out]').innerHTML = o + '</div><button type="button" class="ezw__link" data-re>' + esc(t.cards.again) + '</button></div>';
                    body.querySelector('[data-re]').addEventListener('click', build);
                  }, 650);
                }
              });
            });
          }
          build();
        },
        zodiac: function (body) {
          var h = '<div class="ezw__opts ezw__opts--6">';
          t.zodiac.list.forEach(function (z, i) { h += '<button type="button" class="ezw__opt ezw__opt--col" data-z="' + i + '" aria-pressed="false"><span class="ezw__sym" aria-hidden="true">' + z[0] + '︎</span>' + esc(z[1]) + '</button>'; });
          body.innerHTML = h + '</div><div data-out aria-live="polite"></div>';
          var out = body.querySelector('[data-out]');
          body.querySelectorAll('[data-z]').forEach(function (b) {
            b.addEventListener('click', function () {
              body.querySelectorAll('[data-z]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
              var z = t.zodiac.list[+b.dataset.z];
              var also = z[4].split(',').map(nm).join(', ');
              var zp = img(z[2]);
              var vis = zp ? '<div class="ezw__zimg"><img src="' + zp + '" alt="' + esc(nm(z[2])) + '"><span class="ezw__zbadge" aria-hidden="true">' + z[0] + '︎</span></div>' : '<div class="ezw__zsym" aria-hidden="true">' + z[0] + '︎</div>';
              out.innerHTML = '<div class="ezw__res ezw__zod">' + vis + '<div><p class="ezw__lab">' + esc(z[1]) + ' · ' + esc(t.zodiac.lab) + '</p><h3 class="ezw__rn ezw__big">' + dot(z[2]) + ' ' + esc(nm(z[2])) + '</h3><p class="ezw__rt">' + esc(z[3]) + '</p><p class="ezw__also">' + esc(t.zodiac.also + also) + '</p>' + more(z[2]) + '</div></div>';
              if (window.matchMedia('(max-width: 749px)').matches) out.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          });
        },
        mood: function (body) {
          var h = '<div class="ezw__opts ezw__opts--4">';
          t.mood.list.forEach(function (m, i) { h += '<button type="button" class="ezw__opt ezw__opt--col" data-m="' + i + '" aria-pressed="false">' + esc(m[0]) + '<small>' + esc(m[1]) + '</small></button>'; });
          body.innerHTML = h + '</div><div data-out aria-live="polite" style="margin-top:36px"></div>';
          var out = body.querySelector('[data-out]');
          body.querySelectorAll('[data-m]').forEach(function (b) {
            b.addEventListener('click', function () {
              body.querySelectorAll('[data-m]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
              var m = t.mood.list[+b.dataset.m];
              out.innerHTML = single(m[2], t.mood.lab, '', m[3], m[4]);
              out.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
          });
        }
      };

      function close() {
        panel.hidden = true;
        panel.innerHTML = '';
        items.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        var last = root.querySelector('[data-ezw-open="' + current + '"]');
        current = '';
        if (last) { last.focus({ preventScroll: true }); last.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }

      items.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var k = btn.dataset.ezwOpen;
          if (current === k) { close(); return; }
          current = k;
          items.forEach(function (b) { b.setAttribute('aria-expanded', b === btn ? 'true' : 'false'); });
          panel.innerHTML = shell(t[k], '');
          panel.hidden = false;
          R[k](panel.querySelector('[data-body]'));
          panel.querySelector('[data-back]').addEventListener('click', close);
          panel.focus({ preventScroll: true });
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ez-door"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ezd]').forEach(function (root) {
      if (root.dataset.ezdReady) return;
      root.dataset.ezdReady = '1';
      var list = [];
      try { list = JSON.parse(root.querySelector('[data-ezd-data]').textContent); } catch (e) {}
      if (list.length < 3) return;

      var doors = root.querySelectorAll('[data-ezd-door]');
      var prompt = root.querySelector('[data-ezd-prompt]');
      var promptText = prompt.textContent;
      var result = root.querySelector('[data-ezd-result]');
      var nameEl = root.querySelector('[data-ezd-name]');
      var kwEl = root.querySelector('[data-ezd-kw]');
      var msgEl = root.querySelector('[data-ezd-msg]');
      var shop = root.querySelector('[data-ezd-shop]');
      var again = root.querySelector('[data-ezd-again]');
      var picks = [];
      var done = false;

      function deal() {
        var pool = list.slice();
        picks = [];
        for (var i = 0; i < 3; i++) picks.push(pool.splice(Math.floor(Math.random() * pool.length), 1)[0]);
        doors.forEach(function (d) {
          d.classList.remove('is-open', 'is-muted');
          d.removeAttribute('aria-disabled');
          d.querySelector('[data-ezd-found]').textContent = '';
        });
        result.hidden = true;
        prompt.textContent = promptText;
        done = false;
      }

      function open(door) {
        if (done) return;
        done = true;
        var c = picks[+door.dataset.ezdDoor];
        door.querySelector('[data-ezd-found]').textContent = c.n;
        door.classList.add('is-open');
        doors.forEach(function (d) { if (d !== door) { d.classList.add('is-muted'); d.setAttribute('aria-disabled', 'true'); } });
        prompt.textContent = prompt.dataset.open || promptText;
        setTimeout(function () {
          nameEl.textContent = c.n;
          kwEl.textContent = c.k.split(/\s*[,•·]\s*/).join(' · ');
          msgEl.textContent = c.m;
          if (shop) {
            var base = shop.getAttribute('href').split('?')[0];
            shop.setAttribute('href', base + '?q=' + encodeURIComponent(c.n) + '&type=product');
          }
          result.hidden = false;
          if (window.matchMedia('(max-width: 749px)').matches) result.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 700);
      }

      doors.forEach(function (d) { d.addEventListener('click', function () { open(d); }); });
      again.addEventListener('click', function () {
        deal();
        doors[0].focus({ preventScroll: true });
        root.querySelector('.ezd__prompt').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      deal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-kristaly-lexikon"]) return;
  try {
    
  (function () {
    var norm = function (s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); };
    var letterOf = function (s) { return norm(s).charAt(0).toUpperCase(); };

    document.querySelectorAll('[data-ezl]').forEach(function (root) {
      if (root.dataset.ezlReady) return;
      root.dataset.ezlReady = '1';
      var header = document.querySelector('.section-header, .shopify-section-group-header-group, sticky-header, header-component');
      if (header && getComputedStyle(header).position === 'sticky') {
        root.style.setProperty('--ezl-sticky-offset', header.offsetHeight + 'px');
      }

      var pageSize = parseInt(root.dataset.pageSize, 10) || 24;
      var shown = pageSize;
      var grid = root.querySelector('[data-ezl-grid]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-ezl-item]'));
      var heads = root.querySelectorAll('[data-ezl-head]');
      var input = root.querySelector('[data-ezl-search]');
      var chips = root.querySelectorAll('button[data-ezl-letter]');
      var more = root.querySelector('[data-ezl-more]');
      var empty = root.querySelector('[data-ezl-empty]');
      var count = root.querySelector('[data-ezl-count]');
      var letter = '';

      function render() {
        var q = input ? norm(input.value) : '';
        var filtering = q || letter;
        var matches = items.filter(function (el) {
          return (!letter || el.dataset.letter === letter) && (!q || norm(el.dataset.name).indexOf(q) !== -1);
        });
        items.forEach(function (el) { el.hidden = true; });
        matches.forEach(function (el, i) { el.hidden = !filtering && i >= shown; });
        var visible = {};
        items.forEach(function (el) { if (!el.hidden) visible[el.dataset.letter] = true; });
        heads.forEach(function (h) { h.hidden = !visible[h.dataset.ezlHead]; });
        more.hidden = !!filtering || matches.length <= shown;
        empty.hidden = matches.length > 0;
        count.textContent = matches.length + ' ' + (root.dataset.countLabel || '');
      }

      /* Rebuild the grid from every loaded article: sort, letter dividers, A–Z buttons. */
      function rebuild() {
        var alpha = root.dataset.sort === 'alpha';
        var locale = root.dataset.lang === 'en' ? 'en' : 'hu';
        var seen = {};
        items = items.filter(function (el) {
          var key = el.querySelector('a') ? el.querySelector('a').getAttribute('href') : el.dataset.title;
          if (seen[key]) return false;
          seen[key] = true;
          return true;
        });
        items.forEach(function (el) { el.dataset.letter = letterOf(el.dataset.title); });
        if (alpha) {
          items.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title, locale, { sensitivity: 'base' }); });
        }
        var frag = document.createDocumentFragment();
        var prev = '';
        var present = {};
        items.forEach(function (el) {
          var l = el.dataset.letter;
          present[l] = true;
          if (alpha && l !== prev) {
            var h = document.createElement('li');
            h.className = 'ezl__head';
            h.setAttribute('data-ezl-head', l);
            h.setAttribute('aria-hidden', 'true');
            h.innerHTML = '<span></span>';
            h.firstChild.textContent = l;
            frag.appendChild(h);
            prev = l;
          }
          frag.appendChild(el);
        });
        grid.innerHTML = '';
        grid.appendChild(frag);
        heads = grid.querySelectorAll('[data-ezl-head]');
        chips.forEach(function (c) {
          var l = c.dataset.ezlLetter;
          if (!l) return;
          var on = !!present[l];
          c.classList.toggle('is-off', !on);
          c.disabled = !on;
        });
      }

      function loadRest() {
        var pages = parseInt(root.dataset.pages, 10) || 1;
        var current = parseInt(root.dataset.current, 10) || 1;
        if (pages < 2) return;
        var base = window.location.pathname;
        var jobs = [];
        for (var p = 1; p <= pages; p++) {
          if (p === current) continue;
          jobs.push(
            fetch(base + '?page=' + p + '&section_id=' + encodeURIComponent(root.dataset.section), { credentials: 'same-origin' })
              .then(function (r) { return r.ok ? r.text() : ''; })
              .catch(function () { return ''; })
          );
        }
        Promise.all(jobs).then(function (htmls) {
          var parser = new DOMParser();
          var added = 0;
          htmls.forEach(function (html) {
            if (!html) return;
            var doc = parser.parseFromString(html, 'text/html');
            doc.querySelectorAll('[data-ezl-item]').forEach(function (el) {
              items.push(document.importNode(el, true));
              added++;
            });
          });
          if (!added) return;
          rebuild();
          var pag = root.querySelector('[data-ezl-pagination]');
          if (pag) pag.hidden = true;
          render();
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (chip.disabled) return;
          letter = chip.dataset.ezlLetter;
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          render();
        });
      });
      if (input) input.addEventListener('input', render);
      more.addEventListener('click', function () { shown += pageSize; render(); });
      render();
      loadRest();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["numerology-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('numerology-calculator')) return;

    class NumerologyCalculator extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-ns-form]');
        this.input = this.querySelector('[data-ns-input]');
        this.error = this.querySelector('[data-ns-error]');
        this.result = this.querySelector('[data-ns-result]');
        this.chips = this.querySelector('[data-ns-chips]');
        this.none = this.querySelector('[data-ns-none]');
        this.live = this.querySelector('[data-ns-live]');
        this.grid = this.closest('.numerology-story')?.querySelector('[data-ns-grid]');
        this.input.max = new Date().toISOString().slice(0, 10);
        this.form.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit);
      }

      onSubmit = (event) => {
        event.preventDefault();
        const value = this.input.value;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          this.error.hidden = false;
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus();
          return;
        }
        this.error.hidden = true;
        this.input.removeAttribute('aria-invalid');
        this.render(NumerologyCalculator.missingNumbers(value));
      };

      static missingNumbers(isoDate) {
        const present = new Set(isoDate.replace(/\D/g, '').split(''));
        const missing = [];
        for (let n = 1; n <= 9; n++) {
          if (!present.has(String(n))) missing.push(n);
        }
        return missing;
      }

      render(missing) {
        this.chips.replaceChildren(
          ...missing.map((n) => {
            const li = document.createElement('li');
            li.className = 'numerology-story__chip';
            li.textContent = n;
            return li;
          })
        );
        this.none.hidden = missing.length > 0;
        this.result.hidden = false;
        this.live.textContent = `${this.querySelector('.numerology-story__result-label')?.textContent || ''} ${missing.join(', ')}`;

        if (!this.grid) return;
        this.grid.classList.toggle('has-result', missing.length > 0);
        this.grid.querySelectorAll('[data-number]').forEach((card) => {
          const isMissing = missing.includes(Number(card.dataset.number));
          card.classList.toggle('is-missing', isMissing);
          const flag = card.querySelector('[data-ns-flag]');
          if (flag) flag.hidden = !isMissing;
        });
      }
    }

    customElements.define('numerology-calculator', NumerologyCalculator);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zodiac-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ezzReady) return;
      root.dataset.ezzReady = '1';
      var signs = root.querySelectorAll('[data-ezz-select]');
      var panels = root.querySelectorAll('[data-ezz-panel]');
      var form = root.querySelector('[data-ezz-form]');
      var results = root.querySelector('[data-ezz-results]');
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

      function select(i, opts) {
        opts = opts || {};
        var active = null;
        panels.forEach(function (p) { var on = p.dataset.ezzPanel === String(i); p.hidden = !on; if (on) active = p; });
        signs.forEach(function (s) { var on = s.dataset.ezzSelect === String(i); s.classList.toggle('is-active', on); s.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        if (!active) return;
        root.querySelectorAll('[data-ezz-now]').forEach(function (n) { n.hidden = true; });
        if (opts.now) { var n = active.querySelector('[data-ezz-now]'); if (n) n.hidden = false; }
        if (opts.hash !== false && history.replaceState) history.replaceState(null, '', '#' + active.dataset.slug);
        if (opts.scroll) results.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }

      function signFor(month, day) {
        var md = month * 100 + day, best = null, bestStart = -1, last = null, lastStart = -1;
        signs.forEach(function (s) {
          var p = (s.dataset.start || '').split('-'); var st = parseInt(p[0], 10) * 100 + parseInt(p[1], 10);
          if (st <= md && st > bestStart) { bestStart = st; best = s; }
          if (st > lastStart) { lastStart = st; last = s; }
        });
        return (best || last).dataset.ezzSelect;
      }

      signs.forEach(function (s) { s.addEventListener('click', function () { select(s.dataset.ezzSelect, { scroll: true }); }); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var m = parseInt(root.querySelector('[data-ezz-month]').value, 10);
        var d = parseInt(root.querySelector('[data-ezz-day]').value, 10);
        if (!m || !d) { (m ? root.querySelector('[data-ezz-day]') : root.querySelector('[data-ezz-month]')).focus(); return; }
        select(signFor(m, d), { scroll: true });
      });

      root.querySelectorAll('[data-ezz-share]').forEach(function (b) {
        b.addEventListener('click', function () {
          var url = location.href, title = document.title;
          if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
          if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(function () {
              var t = document.createElement('div'); t.className = 'ezz__toast'; t.setAttribute('role', 'status'); t.textContent = root.dataset.copied;
              root.appendChild(t); setTimeout(function () { t.remove(); }, 1800);
            });
          }
        });
      });

      var slug = (location.hash || '').replace('#', ''), done = false;
      if (slug) panels.forEach(function (p) { if (p.dataset.slug === slug) { select(p.dataset.ezzPanel, { hash: false }); done = true; } });
      if (!done && signs.length) { var now = new Date(); select(signFor(now.getMonth() + 1, now.getDate()), { now: true, hash: false }); }
    }
    document.querySelectorAll('[data-ezz]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-ezz]'); if (r) init(r); });
    document.addEventListener('shopify:block:select', function (e) {
      var p = e.target.closest && e.target.closest('[data-ezz-panel]');
      var r = p && p.closest('[data-ezz]');
      if (r) { var b = r.querySelector('[data-ezz-select="' + p.dataset.ezzPanel + '"]'); if (b) b.click(); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
